import { ReactNode } from 'react'

import { F0Box, F0TagDot } from '@factorialco/f0-react'

import { AtsHiringStageNames, UNASSIGNED_STAGE } from 'modules/ats/lib/utils/hiringStages'

import { phaseColor } from 'modules/ats/components/ApplicationPhaseTag'

interface Props {
  stageName: AtsHiringStageNames
  stageLabel: string
  children?: ReactNode
}

export const HiringStageBox = ({ stageName, stageLabel, children }: Props) => {
  const color = stageName === UNASSIGNED_STAGE ? 'smoke' : phaseColor(stageName)

  return (
    <F0Box
      display="flex"
      flexDirection="column"
      gap="lg"
      padding="md"
      borderRadius="xl"
      border="default"
      background={stageName === UNASSIGNED_STAGE ? 'critical' : 'primary'}
    >
      <F0TagDot color={color} text={stageLabel} />
      {children}
    </F0Box>
  )
}
